import { CircularProgress, Stack } from "@mui/joy";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { axiosInstance } from "../../api";
import {
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "../../api/paymentApi";
import { BottomNextButton } from "../../components/common/BottomNextButton";
import CustomTypography from "../../components/common/CustomTypography";
import { paymentOrderAtom } from "../../recoil/paymentOrderAtom";
import { userAtom } from "../../recoil/userAtom";
import { theme } from "../../styles/theme";

export default function RefundAmount({
  pageSeq,
}: {
  pageSeq: number;
}) {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);

  useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT, user?.userId],
    () => paymentApi.getOrderDetail(),
    {
      enabled:
        !!axiosInstance.defaults.headers["X-Auth-Token"] && !!user?.accessToken,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  const cancelableAmount = paymentOrderState?.cancelableAmount;

  if (cancelableAmount === undefined) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
        <CircularProgress color="neutral" />
      </Stack>
    );
  }

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {`환불 규정에 따라 환불 금액은 ${cancelableAmount.toLocaleString(
            "ko-KR"
          )}원입니다.`}
        </CustomTypography>
      </Stack>

      <BottomNextButton
        disabled={cancelableAmount === 0}
        onClick={() => navigate(`/refund?seq=${pageSeq + 1}`)}
        text={"다음"}
      />
    </Stack>
  );
}
